/* nylstudios — conversion helpers: honest low-stock note + launch-day CTA label. Tiny, no scroll work. */
(function () {
  'use strict';
  var d = document;

  /* Low stock: real inventory for the chosen variant, shown only after a size is picked. */
  var map = d.getElementById('variantStock'), note = d.getElementById('stockNote');
  var idIn = d.querySelector('#pform [data-variant-id]');
  if (map && note && idIn) {
    var stock = {};
    try { stock = JSON.parse(map.textContent); } catch (e) {}
    var th = parseInt(note.getAttribute('data-threshold'), 10) || 5;
    var update = function () {
      var sizes = d.querySelector('#pform .sizes');
      var picked = !sizes || !!sizes.querySelector('[aria-pressed="true"]');
      var q = stock[idIn.value];
      if (picked && typeof q === 'number' && q > 0 && q <= th) {
        note.textContent = 'Only ' + q + ' left in this size';
        note.hidden = false;
      } else {
        note.hidden = true;
      }
    };
    d.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('#pform [data-option] button')) setTimeout(update, 0);
    });
    update();
  }

  /* Launch day: swap "Preview" for the live label once the countdown has passed. */
  Array.prototype.forEach.call(d.querySelectorAll('[data-live-label]'), function (b) {
    var t = Date.parse(b.getAttribute('data-live-at'));
    if (isNaN(t)) return;
    var swap = function () { b.textContent = b.getAttribute('data-live-label'); };
    var ms = t - Date.now();
    if (ms <= 0) swap(); else if (ms < 2147483647) setTimeout(swap, ms);
  });
})();
